export const FETCH_ADMIN_FILES_DATA_REQUEST = "FETCH_ADMIN_FILES_DATA_REQUEST";
export const FETCH_ADMIN_FILES_DATA_SUCCESS = "FETCH_ADMIN_FILES_DATA_SUCCESS";
export const FETCH_ADMIN_FILES_DATA_FAILURE = "FETCH_ADMIN_FILES_DATA_FAILURE";

export const FETCH_FIRMS_FILES_LISTING_DATA_REQUEST = "FETCH_FIRMS_FILES_LISTING_DATA_REQUEST";
export const FETCH_FIRMS_FILES_LISTING_DATA_SUCCESS = "FETCH_FIRMS_FILES_LISTING_DATA_SUCCESS";
export const FETCH_FIRMS_FILES_LISTING_DATA_FAILURE = "FETCH_FIRMS_FILES_LISTING_DATA_FAILURE";
